import BG from './bg.png'
import './App.css';

function App() {
  return (
    <div className="App">
      <div class="w-full h-full fixed"><img src={BG} alt="bg" width={'100%'} /></div>
    </div>
  );
}

export default App;
